import React from 'react';
import cn from 'classnames';

import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';

import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';

import NavLink from '../NavLink';
import Logo from './components/Logo';
import Entries from './components/Entries';
import Profile from './components/Profile';
import SignInIconButton from './components/SignInIconButton';
import SignInBtn from '../SignInBtn';
import SignUpBtn from '../SignUpBtn';
import MenuIcon from './assets/menu.svg';
import pages from '../../resources/pages';

import styles from './styles';

const environment =
  process.env.GATSBY_ENVIRONMENT === 'staging' ? 'staging' : '';

const Topbar = ({ classes, className, loading, onMobileMenuClick }) => {
  const toolbarClassName = cn(classes.toolbar, className);
  return (
    <AppBar position="fixed" className={classes.root}>
      <Toolbar className={toolbarClassName}>
        <NavLink to="/" className={classes.link}>
          <Logo className={classes.logo} />
        </NavLink>
        {!isEmpty(environment) && (
          <Typography variant="h4">{environment}</Typography>
        )}
        <div className={classes.grow} />
        <Entries items={pages} />
        <Hidden smDown>
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <SignInBtn />
              <SignUpBtn className={classes.signOutButton} />
            </>
          )}
          <Profile />
        </Hidden>
        <Hidden mdUp>
          {loading ? (
            <div>
              <CircularProgress />
            </div>
          ) : (
            <SignInIconButton />
          )}
          <IconButton onClick={onMobileMenuClick}>
            <img
              className={classes.icon}
              height={40}
              width={40}
              src={MenuIcon}
              alt="menu-icon"
            />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = state => ({
  loading: state.status.loading,
});

export default connect(mapStateToProps)(withStyles(styles)(Topbar));
